resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Drawer() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;

  this.expanded = -1;
  this.autoCollapse = true;
  this.disabled = false;
  this.iconClass = 'icon-cross';
  this.onClick = null;

  this._drawers = null;
  this._current = null;
  this._ANIMATION_DURATION = 350;

  this.init = function () {
    // Analytics definition
    this.analytics = new Analytics();
    this.analytics.extendEventObject({
      'component-drawer-show': {
        event: "DLevent.Drawer",
        drawerId: function () {
          return this.id;
        },
        drawerAction: function (action) {
          return action;
        }
      }
    });

    $(this.node).addClass("mogo-ui-drawer");

    this._drawers = $(this.node).children();


    var i = 0;
    while (i < this._drawers.length) {
      var drawer = this._drawers[i];
      if ($("a.title", drawer).length == 1 && $(".content", drawer).length == 1) {
        $(drawer).addClass("drawer");
        var title = $("a.title", drawer);
        var content = $(".content", drawer);

        $(title).attr("href", "#");
        $(title).data("num", i);
        $(title).on("click", $.proxy(this._onClickTitle, this));
        $("<div class='" + this.iconClass + "'></div>").appendTo(title);

        // Accessibility
        $(content).attr("id", this.id + "_" + i + "_content");
        $(content).attr("role", "region");
        $(content).attr("aria-expanded", "false");
        $(title).attr("aria-controls", this.id + "_" + i + "_content");

        i++;
      } else {
        console.warn("Drawer: child-" + i + " missing title or content node");
        var nodeToDelete = this._drawers[i];
        this._drawers.splice(i, 1);
        $(nodeToDelete).remove();
      }
    }

    if (this.autoCollapse)
      this._current = -1;

    if (!isNaN(this.expanded) && this.expanded >= 0 && this.expanded <= this._drawers.length - 1) {
      $('.' + this.iconClass, this._drawers[this.expanded]).addClass("expanded");
      $(".content", this._drawers[this.expanded]).css("display", "block");
      $(".content", this._drawers[this.expanded]).attr("aria-expanded", "true");

      if (this.autoCollapse)
        this._current = this.expanded;
    }

    $(this.node).css("display", "block");
  };

  this.initAllReady = function () {
  };

  this.expand = function (pos) {
    if (this.disabled)
      return;

    $('.' + this.iconClass, this._drawers[pos]).addClass("expanded");
    $(".content", this._drawers[pos]).slideDown(this._ANIMATION_DURATION);
    $(".content", this._drawers[pos]).attr("aria-expanded", "true");
    if (this.autoCollapse)
      this._current = pos;

    this.analytics.pushEvent('component-drawer-show', {drawerAction: ['Expand']}, this);
  };

  this.collapse = function (pos, expandPos) {
    if (this.disabled)
      return;

    $('.' + this.iconClass, this._drawers[pos]).removeClass("expanded");
    if (!isNaN(expandPos))
      $(".content", this._drawers[pos]).slideUp({
        duration: this._ANIMATION_DURATION,
        complete: $.proxy(this.expand, this, expandPos)
      });

    else
      $(".content", this._drawers[pos]).slideUp(this._ANIMATION_DURATION);
    $(".content", this._drawers[pos]).attr("aria-expanded", "false");
    if (this.autoCollapse)
      this._current = -1;

    this.analytics.pushEvent('component-drawer-show', {drawerAction: ['Collapse']}, this);
  };

  this._onClickTitle = function (evt) {
    evt.preventDefault();

    if (this.disabled)
      return;

    var target = $(evt.currentTarget).data("num");
    if (this.autoCollapse) {
      if (this._current == -1)
        this.expand(target);
      else if (this._current == target)
        this.collapse(target);
      else {
        this.collapse(this._current);
        this.expand(target);
      }
    } else {
      if ($(".content", this._drawers[target]).css("display") == "none") {
        this.expand(target);
      } else {
        this.collapse(target);
      }
    }

    if (typeof this.onClick === 'function') this.onClick(evt);
  };

  this.disable = function () {
    this.disabled = true;
  };

  this.enable = function () {
    this.disabled = false;
  };
}